import {
  TOGGLE_ALERT
} from './constants'

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TOGGLE_ALERT]: (state, { showAlert }) => ({ ...state, showAlert: showAlert })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  showAlert: false
}
export default function alert (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



/** WEBPACK FOOTER **
 ** ./src/containers/Alert/modules/reducer.js
 **/